export default "__VITE_ASSET__477160e3__"